/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions", "../FluxCommon/ActionsHubManager", "../FluxCommon/StoreManager", "./ImageDetailsActions", "./ImageDetailsStore", "../KubeFactory"], function (require, exports, Actions_1, ActionsHubManager_1, StoreManager_1, ImageDetailsActions_1, ImageDetailsStore_1, KubeFactory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ImageDetailsActionsCreator = /** @class */ (function (_super) {
        __extends(ImageDetailsActionsCreator, _super);
        function ImageDetailsActionsCreator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ImageDetailsActionsCreator.getKey = function () {
            return "image-details-actionscreator";
        };
        ImageDetailsActionsCreator.prototype.initialize = function (instanceId) {
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(ImageDetailsActions_1.ImageDetailsActions);
            this._imageDetailsStore = StoreManager_1.StoreManager.GetStore(ImageDetailsStore_1.ImageDetailsStore);
        };
        ImageDetailsActionsCreator.prototype.setHasImageDetails = function (imageService, listImages) {
            var _this = this;
            imageService && imageService.hasImageDetails(listImages).then(function (hasImageDetails) {
                if (hasImageDetails && hasImageDetails.hasOwnProperty("hasImageDetails")) {
                    _this._actions.setHasImageDetails.invoke(hasImageDetails["hasImageDetails"]);
                }
            });
        };
        ImageDetailsActionsCreator.prototype.getImageDetails = function (imageId, showImageDetailsAction) {
            var _this = this;
            var imageDetails = this._imageDetailsStore.getImageDetails(imageId);
            if (imageDetails) {
                showImageDetailsAction(imageDetails);
            }
            else {
                var imageService = KubeFactory_1.KubeFactory.getImageService();
                imageService && imageService.getImageDetails(imageId).then(function (fetchedImageDetails) {
                    if (fetchedImageDetails) {
                        _this._actions.setImageDetails.invoke(fetchedImageDetails);
                        showImageDetailsAction(fetchedImageDetails);
                    }
                });
            }
        };
        return ImageDetailsActionsCreator;
    }(Actions_1.ActionCreatorBase));
    exports.ImageDetailsActionsCreator = ImageDetailsActionsCreator;
});
